import React from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

export default function CartPanel({ cartItems, onUpdateQty, onRemove, onClearCart, onPlaceOrder, selectedAccount }) {
  const subtotal = cartItems?.reduce((sum, item) => {
    const price = item?.promoPrice || item?.price;
    return sum + price * item?.qty;
  }, 0);
  const tax = subtotal * 0.12;
  const total = subtotal + tax;

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-semibold text-base text-foreground flex items-center gap-2">
          <Icon name="ShoppingCart" size={18} color="var(--color-primary)" strokeWidth={2} />
          Cart
          {cartItems?.length > 0 && (
            <span className="bg-primary text-primary-foreground text-xs font-data w-5 h-5 rounded-full flex items-center justify-center">
              {cartItems?.length}
            </span>
          )}
        </h3>
        {cartItems?.length > 0 && (
          <button onClick={onClearCart} className="font-caption text-xs text-destructive hover:underline">
            Clear All
          </button>
        )}
      </div>
      {cartItems?.length === 0 ? (
        <div className="flex-1 flex flex-col items-center justify-center text-center py-8">
          <Icon name="ShoppingCart" size={40} color="var(--color-muted-foreground)" strokeWidth={1.5} />
          <p className="font-caption text-sm text-muted-foreground mt-3">Cart is empty</p>
          <p className="font-caption text-xs text-muted-foreground mt-1">Add products from the catalog</p>
        </div>
      ) : (
        <>
          <div className="flex-1 overflow-y-auto custom-scrollbar space-y-3 pr-1">
            {cartItems?.map((item) => {
              const price = item?.promoPrice || item?.price;
              return (
                <div key={item?.id} className="flex gap-2 p-2 bg-muted rounded-md">
                  <div className="flex-1 min-w-0">
                    <p className="font-caption text-xs font-medium text-foreground line-clamp-1">{item?.name}</p>
                    <p className="font-data text-xs text-muted-foreground">
                      ₱{price?.toLocaleString("en-PH", { minimumFractionDigits: 2 })} / {item?.unit}
                    </p>
                    {item?.promoPrice && (
                      <span className="font-caption text-xs text-warning">Promo applied</span>
                    )}
                  </div>
                  <div className="flex flex-col items-end gap-1 flex-shrink-0">
                    <button onClick={() => onRemove(item?.id)} className="text-muted-foreground hover:text-destructive transition-colors">
                      <Icon name="X" size={12} color="currentColor" strokeWidth={2.5} />
                    </button>
                    <div className="flex items-center gap-1">
                      <button
                        onClick={() => onUpdateQty(item?.id, item?.qty - 1)}
                        className="w-6 h-6 rounded bg-card border border-border flex items-center justify-center hover:bg-muted transition-colors"
                      >
                        <Icon name="Minus" size={10} color="currentColor" strokeWidth={2.5} />
                      </button>
                      <span className="font-data text-xs w-6 text-center">{item?.qty}</span>
                      <button
                        onClick={() => onUpdateQty(item?.id, item?.qty + 1)}
                        className="w-6 h-6 rounded bg-card border border-border flex items-center justify-center hover:bg-muted transition-colors"
                        disabled={item?.qty >= item?.stock}
                      >
                        <Icon name="Plus" size={10} color="currentColor" strokeWidth={2.5} />
                      </button>
                    </div>
                    <p className="font-data text-xs font-semibold text-foreground">
                      ₱{(price * item?.qty)?.toLocaleString("en-PH", { minimumFractionDigits: 2 })}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-4 pt-4 border-t border-border space-y-2">
            <div className="flex justify-between font-caption text-sm text-muted-foreground">
              <span>Subtotal</span>
              <span className="font-data">₱{subtotal?.toLocaleString("en-PH", { minimumFractionDigits: 2 })}</span>
            </div>
            <div className="flex justify-between font-caption text-sm text-muted-foreground">
              <span>VAT (12%)</span>
              <span className="font-data">₱{tax?.toLocaleString("en-PH", { minimumFractionDigits: 2 })}</span>
            </div>
            <div className="flex justify-between font-heading font-semibold text-base text-foreground pt-2 border-t border-border">
              <span>Total</span>
              <span className="font-data text-primary">₱{total?.toLocaleString("en-PH", { minimumFractionDigits: 2 })}</span>
            </div>
            <Button
              variant="default"
              fullWidth
              iconName="CheckCircle"
              iconPosition="left"
              iconSize={16}
              onClick={onPlaceOrder}
              disabled={!selectedAccount}
              className="mt-2"
            >
              Place Order
            </Button>
            {!selectedAccount && (
              <p className="font-caption text-xs text-warning text-center">Select an account to place order</p>
            )}
          </div>
        </>
      )}
    </div>
  );
}